<template>
  <div id="curso" class="curso">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Curso',
}
</script>

<style lang="sass"></style>
